/**
 * True when the app is being viewed through a share link (?share=<linkId>).
 * Share sessions run with the link's demand set and skip creator-only data
 * loads such as the My Custom Schedules index roots.
 */
export function isShareSession() {
    return !!new URLSearchParams(window.location.search).get("share")
}
